import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { View } from "react-native";
var Dummy = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
export var PanGestureHandler = Dummy;
export var GestureHandlerRootView = View;
export var GestureState = {
    UNDETERMINED: 0,
    FAILED: 1,
    BEGAN: 2,
    CANCELLED: 3,
    ACTIVE: 4,
    END: 5
};
